import { Title } from '../../../components'
import {
    Container
} from './styles'

import img3 from '../../../assets/pelve/img3.png'
import img4 from '../../../assets/pelve/img4.png'
import img5 from '../../../assets/pelve/img5.png'
import img6 from '../../../assets/pelve/img6.png'
import img7 from '../../../assets/pelve/img7.png'


export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Reformatações multiplanares, tridimensionais e imagens de referência</Title>

                    <section className="mt-2 p-3">

                        <p>
                        Na reformatação no plano axial os cortes devem seguir a orientação da superior para inferior,
selecionar imagem no plano coronal como referência. Deixar os cortes perpendiculares ao sacro,
utilizar o plano coronal.
                        </p>

                        <p>
                            Para filme, os cortes axiais (sem ou com contraste I.V.) devem ter início 1 corte acima da crista ilíaca e término 1cm abaixo do trocanter maior.
                        </p>

                        <img className="img-fluid" src={img3} alt="Reformatacoes" />

                        <p>
                        Na reformatação no plano coronal (sem ou com contraste I.V.) os cortes devem seguir a orientação
da posterior para anterior, utilizar a cabeça do fêmur como referência para angulação, deixar os
cortes paralelos a elas, utilizar imagem no plano axial como referência. No plano sagital deixar os
cortes paralelos ao maior eixo da pelve, utilizar imagem sagital como referência.
                        </p>
                        <p>
                        Para back-up os cortes coronais devem ter início antes da pele do dorso e término logo após a pele
da região ventral. 
                        </p>

                        <img className="img-fluid" src={img4} alt="Reformatacoes" />

                        <p>
                        Para filme, os cortes coronais filme devem ter início 1cm antes do sacro e término 1cm após o púbis. 
                        </p>
                        <img className="img-fluid" src={img5} alt="Reformatacoes" />

                        <p>
                        Na reformatação no plano sagital os cortes devem seguir a orientação da esquerda para direita,
perpendiculares a cabeça do fêmur, utilizar imagem no plano axial como referência. 
                        </p>

                        <p>
                        Para back-up os cortes sagitais devem ter início antes da pele do flanco esquerdo e término logo
após o final da pele do flanco direito.
                        </p>


                        <img className="img-fluid" src={img6} alt="Reformatacoes" />

                        <img className="img-fluid" src={img7} alt="Reformatacoes" />


                        


                    </section>
                </div>
            </div>
        </Container>
    )
}